
import rsa from "../crypto/rsa";
import sha512 from '../crypto/sha512'
//const sha512=require('../crypto/sha512.js');


const publicKey =
  "-----BEGIN PUBLIC KEY-----\n" +
  "MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA8Df40sRBUL+PbE+GJbJG\n" +
  "1d1zNPbnkgyg2f3ax1TSxsrKZD6l6IxO7bkdLrGB9e5wYRa8oqIUXEKo7qe9N+dt\n" +
  "zaOg0PAmEyDVcLk/iXjlaj73uyjnIQEbh/TcoEk8UnZPmOytg0QnZwWcV+tQG6hV\n" +
  "Q2VdEHOSQDLyINs9i5NXvncfx6UPi8SoK7DrLtNeKBPhGfCpc5fLZBuzPvhmUx4J\n" +
  "KItdSieUhKhdfkOz3ZkTAfCU64/XkeTYxhWi25L06i+cr5CUo4OJ1Ai/fOxTA5O/\n" +
  "cR+/akEty697Tw+cGXhnHEzV41fW6v/9NMd5l4KEbjaBFjBaEFuuMOw99ViTX0s/\n" +
  "meF64WgEjKxSruGlrwM+3fdKTkPkoVx7YauHH5zGNoozJXit4i4+YkYIvNNY8qbE\n" +
  "fH4D3pRyh4n7QyisYaHJapcHr8JwtZxpjYxm6mNY1d4qCx9aGFJGUcwYRvi8JSW/\n" +
  "aiHSrjSBTZ3UKf+rzmHYw8uAnunKJqQKYUvxQSeYd1tXkZyGOwM6PKxpPUtd+vq+\n" +
  "I0jVG3HRo1aSBjkrp86ej+Y6/GI7RHR1jfekxMDduJb7Rsol5VdqVHBalIS4Wg6T\n" +
  "5n2UKEe60nBj4zXr/6Arc/fI8b7r3dD2STuKdwyYwGKZbzxk/E5BznL79TOLvGC5\n" +
  "qnadWKZdWmI+rtvVireF6GkCAwEAAQ==\n" +
  "-----END PUBLIC KEY-----";
/*
const publickey2 =
  "-----BEGIN PUBLIC KEY-----MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQ\n" +
  "KCAQBsXhVZysw83DxtKYC6n+zVVQ9Z+zhR7UToXrNadHU9pl/7XU5ZIZsYa4D7dW\n" +
  "aiAxBW3ZEvnhyDzinwhQMyQmZ9QVhuBUTyb9ppxFeGnIVxV+m1zpSaJTbN8T2JbJ\n" +
  "UlUL2+IwFreMBMK2aQO45XbYL70LHVr1aoqVGb1HP3Jt4IIqoU1Q13tkb5n1wtBh\n" +
  "GiImPpYxli6USsUiqCwURQi3vk2Zy8TXB48w7SKXQyAoX5C50K4SDz+hfwHopwEL\n" +
  "b/P3M8xG2UQBC3Z5HwW9pje4/nLl5IJdJWPidpLPkJOznzZdPiA9XwWH9HN6zNBx\n" +
  "yC+eyjW1BS3Besmn9DO3Ow7EnTAgMBAAE=\n" +
  "-----END PUBLIC KEY-----";*/
const privateKey =
  "-----BEGIN RSA PRIVATE KEY-----\n" +
  "MIIEnwIBAAKCAQBsXhVZysw83DxtKYC6n+zVVQ9Z+zhR7UToXrNadHU9pl/7XU5Z\n" +
  "IZsYa4D7dWaiAxBW3ZEvnhyDzinwhQMyQmZ9QVhuBUTyb9ppxFeGnIVxV+m1zpSa\n" +
  "JTbN8T2JbJUlUL2+IwFreMBMK2aQO45XbYL70LHVr1aoqVGb1HP3Jt4IIqoU1Q13\n" +
  "tkb5n1wtBhGiImPpYxli6USsUiqCwURQi3vk2Zy8TXB48w7SKXQyAoX5C50K4SDz\n" +
  "+hfwHopwELb/P3M8xG2UQBC3Z5HwW9pje4/nLl5IJdJWPidpLPkJOznzZdPiA9Xw\n" +
  "WH9HN6zNBxyC+eyjW1BS3Besmn9DO3Ow7EnTAgMBAAECgf8v1VeXSuzb8Fq71JX9\n" +
  "ypm/kMw1663we8ruxt5kDwOxMr8rNQRgU3UiUlGcrTWgTbnoneR4IFJ124qnoA7J\n" +
  "IIYcw7tE1Q6Z9MVz6ja4NF6yqRuAJK9zWvnV7aY8ArHSxtD6HHmD9sjq1j1vbNpn\n" +
  "vO8UOApHSB34VMSxBBYsAfv/mrk4vMW6jSmolnjNuVgR3at2msliEJzgPiFYAh+t\n" +
  "gSC2fTfqYeYMVujVjA2Fyy2JnOCwHhBAnUjpzFW4AcvawdPipxTJjjBKPDWCV9cX\n" +
  "WfQKtMSDilGf0E1ujj8iT7Ij2KlrcMAGzW/JDDnxCBTjY3bz2nxVj5mgQjPbQYZk\n" +
  "iZECgYEAvVKoGUHdKFdJf3wSW/0qFL83XmoZX/hxI+G/dQjSrCvPRuEIlbibKYvn\n" +
  "3mCLVRKZPRHUc9trV71pyufc1+Hl8wtXBT++Vb2fA4SxO5CLKdNGouNKCuBG5lWp\n" +
  "72CBCIxteY4hRBbq1ZffdMYGX6qB4t64Qr1BM++DCblV+8A9OWkCgYEAkoh+hmk4\n" +
  "hBr4rn6q4SfkgoZvIPJaGPFf4Q1vwmYEA1Y6EPmf5RpsYXuX7gOncdlT+5ws9MDu\n" +
  "8xvc9v9/uy44PQnTbiE5Sg02b0hu7SHMDNU+QI80gx+TvR8pJYxHCd3QBebo+0Tr\n" +
  "ewsh0hrO2DaN5L9ioGp0hm4epNpqRKFAJdsCgYBbUJTXqdb78C35GWTZjaBQZXJV\n" +
  "TaNzkKcxgV8RGfJTLMZLD5tOa74bKenqbnKF0/SpagIo53o81ZVDUtZIIiMBOUT9\n" +
  "uSMaw90Am23Ipw0YXVlCk5JQ8KAB1OukE83oy6K58H3HE66s2xXigujsF5eST45c\n" +
  "UmAypqFzfTsltDFTkQKBgCM58wjHBNIlVcFFLDlCiNmkDdUizewPItiMjWBze+V9\n" +
  "diociIbgKkvpFWYftMJW16y2J8yTER6ahS1P0Nojy1tJIG3qSMZ3lK1+AUS6ij5P\n" +
  "iU6l3p7jGXYupoqjRXSmwVqZ30qAkAedbnz++tjZjJUAOWqNDQRANte0tjVXen9f\n" +
  "AoGAFj3xOZUYw87BXI2QXlaWnfdJal0+Ub9k3E9C6hNR1rakA/EpQqYnqLqgR0Zb\n" +
  "ChgKQCtW/zYKI/VfktyQMeDzznRDWREMEgXfhJjTLDvUGyaf+AXsT4lF29TqaOPE\n" +
  "6aZBBIhsxnEDCyNozomEnLjjM2AOSnboUBtXDKQL9SiKGiE=\n" +
  "-----END RSA PRIVATE KEY-----";

export function encriptarTrama(tramaEntrada) {
  var rsa_ = new rsa();
  rsa_.setPublicCert(publicKey);
  var tramaEncriptada = rsa_.encrypt_b64(tramaEntrada);
  return tramaEncriptada;
}

export function encriptarContrasenia(contrasenia) {
  return sha512(contrasenia);
}

export const desencriptarRsa = trama => {
  try {
    var rsa_ = new rsa();
    rsa_.setPrivateCert(privateKey);
    return rsa_.decrypt(trama);
  } catch (error) {
    return "error";
  }
};

export function stringABase64(str) {
  try {
    return window.btoa(unescape(encodeURIComponent(str)));
  } catch (error) {
    return str
  }

}

export function desencriptarTramaAES(tramaEntrada, key, iv) {
  try {
    let llave = desencriptarRsa(key);
    let cuatro = desencriptarRsa(iv);
    llave = llave.replace(new RegExp('"', "g"), "");
    cuatro = cuatro.replace(new RegExp('"', "g"), "");
    var noencriptado = decryptAES(tramaEntrada, llave, cuatro);
  } catch (error) {
    console.log(error);
  }
  //console.log(JSON.parse(noencriptado));
  return JSON.parse(noencriptado);
}

// function encryptAES(text, key, iv) {
//   var crypto = require("crypto");
//   var alg = "aes-256-cbc";
//   key = new Buffer(key);
//   iv = new Buffer(iv);
//   var cipher = crypto.createCipheriv(alg, key, iv);
//   var encoded = cipher.update(text, "ascii", "base64");
//   encoded += cipher.final("base64");
//   return encoded;
// }

function decryptAES(data, key, iv) {
  var crypto = require("crypto");
  var decipher = crypto.createDecipheriv("aes-256-cbc", key, iv),
    buffer = Buffer.concat([
      decipher.update(Buffer.from(data, "base64")),
      decipher.final()
    ]);
  return buffer.toString();
}

// function decryptAES2(encryptedText, key, iv) {
//   var crypto = require("crypto");
//   var alg = "aes-256-cbc";
//   key = new Buffer(key);
//   iv = new Buffer(iv);
//   var encrypted = new Buffer(encryptedText, "base64");
//   var decipher = crypto.createDecipheriv(alg, key, iv);
//   var decoded = decipher.update(encrypted, "binary", "ascii");
//   decoded += decipher.final("ascii");
//   return decoded;
// }


